import React, { Component } from "react";
import TextInputField from '../../infra/components/formInput/CustomTextInput' 
import { fromJS } from "immutable";
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { bindActionCreators } from 'redux'

import ResetPasswordAction from '../../store/action/UserLogin/ResetPassword'
import StoreActionLogout from '../../store/action/LogoutAction'

class Form extends Component{
    constructor(props){
        super(props);
        this.state ={
          form : fromJS({
            'new-password':'',
            'new-password-re' : '',
            'username':'',
          }),
          errors: fromJS({}),
          error: '',
        };
    
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }   
    handleChange(field, value) {
        var formVal = this.state.form;
        formVal = formVal.set(field,value); 
        this.setState({ form:formVal })
    }

    async handleSubmit(dispatch) {
        const mandatory = fromJS([ 'new-password', 'new-password-re' ,'username'])
        var { errors, form } = this.state;
        this.setState({ errors : fromJS({}) });
        
        var isValid = true;
        mandatory.map((field) => {
            if(form.get(field) === ''){
                errors = errors.set(field, 'cannot empty!')
                isValid = false;
            }
        })
        if(!isValid){
            this.setState({ errors : errors });
            toast.error("mandatory field cannot empty", toast.POSITION.TOP_RIGHT)
        }else{
            if(form.get('new-password') !== form.get('new-password-re')){
                isValid = false;
                toast.error("Password not match!", toast.POSITION.TOP_RIGHT)
            }
        }

        if(isValid){    
            var response = await this.props.resetPasswordAction(form);
            if(response.ok){
                toast.success('Password Reset!');
            }else{
                toast.error('Failed on reset password!');
            }
        }
    }

    render(){
        const { form, errors } = this.state;
        const title = "Reset Password";

        return(
            <div className="clearfix">
            <div className="card-noborder">
                <h4>
                    { title }
                </h4>
            </div>
            <div className="card">
                <div className="body">
                <div className="row no-margin-bottom">
                        <span className="col-sm-2">Username *</span>
                        <div className="col-sm-10">
                            <TextInputField className="form-control"
                                field={'username'}
                                value={ form.get('username')}
                                onChange={(field, value) => this.handleChange(field,value)}
                                placeholder="Username"
                                hasError={errors.has('username')}
                            />
                        </div>
                    </div>
                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">New Password *</span>
                        <div className="col-sm-10">
                            <TextInputField className="form-control"
                                password
                                field={'new-password'}
                                value={ form.get('new-password')}
                                onChange={(field, value) => this.handleChange(field,value)}
                                hasError={errors.has('new-password')}
                            />
                        </div>
                    </div>

                    <div className="row no-margin-bottom">
                        <span className="col-sm-2">Confirm Password *</span>
                        <div className="col-sm-10">
                            <TextInputField className="form-control"
                                field={'new-password-re'}
                                password
                                value={ form.get('new-password-re')}
                                onChange={(field, value) => this.handleChange(field,value)}
                                placeholder="Confirm your new password"
                                hasError={errors.has('new-password-re')}
                            />
                        </div>
                    </div>

                    <div className="form-group row">
                        <span className="col-sm-2"></span>
                        <div className="col-sm-10">
                        <button type="button"
                            className="btn btn-wide btn-success"
                            onClick={ this.handleSubmit }>
                                Submit
                        </button>
                        </div>
                    </div>
                </div>  
            </div>   
            </div>
        )
    }
}

export default connect(
    (state) => {
        return {
  //        supervisorsall: state.user.supervisorsall,
        }
    },
    dispatch => bindActionCreators({
        resetPasswordAction: ResetPasswordAction,
        ActionLogout: StoreActionLogout,
    }, dispatch),
  )(Form);